<section class="section_one" *ngIf="show">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <!-- desktop table view open-->
                <div>
                    <form [formGroup]="campusTrack" #inputField11>
                        <div>
                            <div class="ibox-title report_flexweb">
                                <div>
                                    <h5> CREATE COURSE TRACK MASTER</h5>
                                </div>
                                <div>
                                    <figure>
                                        <img src="../../assets/image/Group 28269.svg" [mat-dialog-close]="true" />
                                    </figure>

                                </div>
                            </div>
                            <div>
                                <div class="row">
                                    <mat-form-field>
                                        <mat-label>Campus</mat-label>
                                        <mat-select formControlName="campusname" class="selectOptions" (click)="Campusinput(matSelect)">
                                            <input matInput type="text" [formControl]="Campus" class="input_border"
                                                [matAutocomplete]="auto" placeholder="select the campus" />
                                            <mat-autocomplete #auto="matAutocomplete"> </mat-autocomplete>
                                            <mat-option *ngFor="let option of classNames | async"
                                                [value]="option?.campusName" (click)="filterCampus(option)" multiple>
                                                {{option.campusName }}
                                            </mat-option>
                                        </mat-select>

                                    </mat-form-field>


                                    <mat-form-field>
                                        <mat-label>Class</mat-label>
                                        <mat-select formControlName="Class" class="selectOptions" (click)="Class1input(matSelect)">
                                            <input matInput type="text" [formControl]="Class1" class="input_border"
                                                [matAutocomplete]="class" placeholder="select the campus" />
                                            <mat-autocomplete #class="matAutocomplete"> </mat-autocomplete>
                                            <mat-option (click)="getClassStreams(data)" [value]="data?.className"
                                                *ngFor="let data of mediums |async ">{{data.displayName}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <mat-form-field>
                                        <mat-label>Stream</mat-label>
                                        <mat-select formControlName="Stream" class="selectOptions" (click)="Stream1input(matSelect)" #inputField4>
                                            <input matInput type="text" [formControl]="Stream1" class="input_border"
                                                [matAutocomplete]="stream" placeholder="select the campus" />
                                            <mat-autocomplete #stream="matAutocomplete"> </mat-autocomplete>
                                            <mat-option [value]="obj?.streamName" (click)="setStream(obj)"
                                                *ngFor="let obj of group |async">{{obj?.streamName}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                </div>
                                <div class="col-lg-12 text-center">
                                    <button class="create" (click)="opendialog()">
                                        create
                                    </button>
                                </div>

                            </div>

                        </div>
                    </form>
                    <!-- desktop table view close-->
                </div>
            </div>
        </div>
    </div>
</section>
<section *ngIf="!show">
    <div class="card-body">
        <div class="det-details">
            <div class="ibox-title report_flexweb">
                <div>
                    <h5>Campus Course Track </h5>
                </div>
                <div>
                    <figure>
                        <img src="../../assets/image/Group 28269.svg" [mat-dialog-close]="true" />
                    </figure>
                </div>
            </div>
            <!-- <mat-divider></mat-divider> -->
            <hr class="line">
            <div class="box2">
                <div class="example-card">
                    <!-- <form [formGroup]="campusTrack12"> -->
                    <select class="search12 form-select form-control  bg-light" (change)="details($event)">
                        <option *ngFor="let data of campuslist " value={{data?.courseTrackId}}>{{data?.courseTrackName}}
                        </option>
                    </select>
                    <div class="box" *ngIf="campusdetails">

                        <div class="campus_dtl">
                            <h3 class="course"> course Track</h3>
                            <h3 class="name">{{campusdetails.courseTrackName}}</h3>
                        </div>

                        <div class="color_1">
                            <div class="campus_dtl">
                                <h3 class="course">Code</h3>
                                <h3 class="name">{{campusdetails.courseTrackCode}}</h3>

                            </div>
                        </div>
                        <div class="campus_dtl">
                            <h3 class="course">className</h3>
                            <h3 class="name">{{campusdetails.className}}</h3>
                        </div>
                        <div class="color_1">
                            <div class="campus_dtl">
                                <h3 class="course">medium</h3>
                                <h3 class="name">{{campusdetails.medium}}</h3>
                            </div>
                        </div>
                        <div class="campus_dtl">
                            <h3 class="course">groupName</h3>
                            <h3 class="name">{{campusdetails.groupName}}</h3>
                        </div>
                        <div class="color_1">
                            <div class="campus_dtl">
                                <h3 class="course">orientation</h3>
                                <h3 class="name">{{campusdetails.orientation}}</h3>
                            </div>
                        </div>
                        <div class="campus_dtl">
                            <h3 class="course">trackType
                            </h3>
                            <h3 class="name">{{campusdetails.trackType}}</h3>
                        </div>
                        <div class="color_1">
                            <div class="campus_dtl">
                                <h3 class="course">streamName</h3>
                                <h3 class="name">{{campusdetails.streamName}}</h3>
                            </div>
                        </div>

                        <div class="campus_dtl">
                            <h3 class="course">coachingType</h3>
                            <h3 class="name">{{campusdetails.coachingType}}</h3>
                        </div>

                        <div class="color_1">
                            <div class="campus_dtl">
                                <h3 class="course">substream</h3>
                                <h3 class="name">{{campusdetails.subStreamName}}</h3>
                            </div>
                        </div>

                        <div class="campus_dtl">
                            <h3 class="course">status</h3>
                            <h3 class="name">{{campusdetails.status}}</h3>
                        </div>

                        <div class="color_1">
                            <div class="campus_dtl">
                                <h3 class="course">createdOn</h3>
                                <h3 class="name">{{campusdetails.createdOn}}</h3>
                            </div>
                        </div>
                        <div class="campus_dtl">
                            <h3 class="course">designation</h3>
                            <h3 class="name">{{campusdetails.designation}}</h3>
                        </div>

                        <hr style="margin: 0px;">
                        <div class="campus_dtl back">
                            <div>
                                <div class="create1">Created By</div>
                                <div class="nameby">{{campusdetails.createdBy}}</div>
                                <div class="dept">{{campusdetails.deptName}}</div>
                            </div>
                            <div>
                                <div class="create1">Approved By</div>
                                <div class="nameby">{{campusdetails.approvedBy}}</div>
                                <div class="dept">{{campusdetails.deptName}}</div>
                            </div>
                        </div>
                    </div>
                    <!-- </form> -->
                    <div class="student" *ngIf="!campusdetails || campusdetails.length <=0">
                        No campus course track details......
                    </div>
                </div>

            </div>

            <div>
                <button class="save text-center" (click)="save()">
                    save
                </button>
            </div>

        </div>
    </div>
</section>


<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>